import React from 'react';
import PropTypes from 'prop-types';
import { withAuthenticationRequired } from '@auth0/auth0-react';

import SplashScreen from 'src/components/SplashScreen';

const AuthGuard = ({ children }) => {
  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default withAuthenticationRequired(AuthGuard, {
  onRedirecting: () => <SplashScreen />
});
